// services/deviceFingerprint.js
// Computes a stable device fingerprint (FingerprintJS OSS) plus a few
// human-readable device hints, sent to the backend Login Policy Engine. The
// backend stays fingerprint-agnostic — a native app can supply its own device
// UUID into the same `deviceFingerprint` field.

import FingerprintJS from '@fingerprintjs/fingerprintjs';

let _agentPromise = null;
let _cached = null;

function parseUserAgent(ua = navigator.userAgent) {
  const os =
    /Windows/i.test(ua) ? 'Windows' :
    /Mac OS X|Macintosh/i.test(ua) ? 'macOS' :
    /Android/i.test(ua) ? 'Android' :
    /iPhone|iPad|iPod/i.test(ua) ? 'iOS' :
    /Linux/i.test(ua) ? 'Linux' : 'Unknown';
  const browser =
    /Edg\//i.test(ua) ? 'Edge' :
    /OPR\/|Opera/i.test(ua) ? 'Opera' :
    /Chrome\//i.test(ua) ? 'Chrome' :
    /Firefox\//i.test(ua) ? 'Firefox' :
    /Safari\//i.test(ua) ? 'Safari' : 'Unknown';
  return { os, browser };
}

/** Returns { deviceFingerprint, deviceName, operatingSystem, browser }. Cached per session. */
export async function getDeviceInfo() {
  if (_cached) return _cached;
  try {
    if (!_agentPromise) _agentPromise = FingerprintJS.load();
    const agent = await _agentPromise;
    const result = await agent.get();
    const { os, browser } = parseUserAgent();
    // Touch/platform hints let the backend catch iPads that report a desktop
    // Mac User-Agent (DESKTOP_ONLY_STRICT policy). Best-effort; used only to
    // strengthen the mobile classification, never to relax it.
    const platform =
      (navigator.userAgentData && navigator.userAgentData.platform) ||
      navigator.platform || '';
    _cached = {
      deviceFingerprint: result.visitorId,
      deviceName: `${os} · ${browser}`,
      operatingSystem: os,
      browser,
      maxTouchPoints: navigator.maxTouchPoints || 0,
      platform,
    };
  } catch (err) {
    // Never block login if fingerprinting fails; backend fail-open handles it
    // for unrestricted users, and restricted users will simply be denied.
    console.warn('[deviceFingerprint] failed to compute fingerprint:', err?.message || err);
    _cached = { deviceFingerprint: null };
  }
  return _cached;
}
